import {
  Box,
  Button,
  ButtonGroup,
  Flex,
  Heading,
  VStack,
} from "@chakra-ui/react";
import React, { useContext, useState } from "react";
import Layout from "../Layout/Layout";
import AvailableVoices from "./AvailableVoices";
import SyncVoices from "./SyncVoices";
import useVoicesHook from "./useVoicesHook";
import { AgencyContext } from "../Settings/AgencyProvider/AgencyProvider";

const Index = () => {
  const { textColor } = useVoicesHook();
  const [selectedTab, setSelectedTab] = useState(0);

  const agency = useContext(AgencyContext);
  const tabs = [
    {
      label: "Available Voices",
      value: "availableVoices",
      children: <AvailableVoices />,
      isVisible: true,
    },
    {
      label: "Sync Your Voices",
      value: "syncVoices",
      children: <SyncVoices />,
      isVisible: agency?.myDetails?.agency_id ? false : true,
    },
  ];

  return (
      <VStack h="100%" spacing={2} borderRadius="md">
        <Flex direction={"column"} gap={3} h={"100%"} w={"100%"}>
          <Flex gap={2} w={"100%"} alignItems="center" p={2}>
            <Heading color={textColor} fontSize="xl">
              Voices
            </Heading>
          </Flex>

          <ButtonGroup spacing="3">
            {tabs
              .filter((tab) => tab.isVisible)
              .map((tab, index) => (
                <Button
                  colorScheme={agency.buttonColorScheme}
                  variant={selectedTab === index ? "solid" : "ghost"}
                  key={tab.value}
                  onClick={() => setSelectedTab(index)}
                >
                  {tab.label}
                </Button>
              ))}
          </ButtonGroup>

          <Box h={"100%"} overflowY={"auto"}>
            {tabs[selectedTab].children}
          </Box>
        </Flex>
      </VStack>
  );
};

export default Index;
